<template>
  <v-dialog content-class="modal-view" v-model="dialog" max-width="700px">
    <v-card>
      <v-card-title class="headline pb-0">
        <span> Aprovação automática </span>
      </v-card-title>

      <v-card-text>
        <div class="auto-approve-container">
          <div class="right">
            <v-card class="preview-card">
              <v-card-text class="wppBack" :style="whatsAppBackgroundStyle">
                <div class="message-box">
                  <Header :selectedInitiative="selectedInitiative" />
                  <Body
                    class="message-body"
                    :selectedInitiative="selectedInitiative"
                  />
                  <Footer
                    class="message-footer"
                    :selectedInitiative="selectedInitiative"
                  />
                </div>
                <Buttons
                  class="message-buttons"
                  :selectedInitiative="selectedInitiative"
                />
              </v-card-text>
            </v-card>
          </div>

          <div class="left d-flex flex-column align-center justify-center">
            <div class="left-content">
              <v-icon class="mb-3" size="130" color="light-green darken-3">
                mdi-check-decagram
              </v-icon>
              <h3>Template aprovado automaticamente</h3>
              <p>
                Se você identificar algo errado na mensagem, pode rever a
                aprovação antes de continuar.
              </p>
              <v-alert type="info" dense>
                Ao rever, a aprovação será removida.
              </v-alert>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outline dark @click="onReview">
          Rever aprovação
        </v-btn>
        <v-btn color="accent" depressed @click="onContinue"> Continuar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Header from "./Preview/Header.vue";
import Body from "./Preview/Body.vue";
import Footer from "./Preview/Footer.vue";
import Buttons from "./Preview/Buttons.vue";

import { mapGetters } from "vuex";

export default {
  name: "AutoApproveDialog",
  props: ["value"],
  components: {
    Header,
    Body,
    Footer,
    Buttons,
  },
  computed: {
    ...mapGetters("initiativeManager", {
      selectedInitiative: "selectedInitiative",
    }),
    whatsAppBackgroundStyle() {
      return {
        backgroundImage: "url(/img/icons/whatsappBackGround.png)",
      };
    },
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        this.$emit("update:value", v);
      },
    },
  },
  methods: {
    onReview() {
      this.$emit("review");
      this.dialog = false;
    },
    onContinue() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.auto-approve-container {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}
.auto-approve-container .left {
  min-height: 160px;
}
.auto-approve-container .left .left-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.auto-approve-container .right {
  flex: 1 1 55%;
}
.preview-card {
  width: 100%;
}
.modal-view {
  border-radius: 0.5em;
}
.buttonCancel {
  background: white !important;
  box-shadow: unset !important;
}
.buttonSubmit {
  background: #00e58d !important;
  color: #00606a !important;
}

.message-box {
  background-color: whitesmoke;
  width: 299px;
  border-radius: 5px;
  padding: 8px;
  margin-top: 20px;
  .message-body {
    margin: 15px 0;
  }
}
.message-buttons {
  margin-top: 5px;
  width: 299px;
}
.wppBack {
  padding-top: 20px;
}
</style>
